import React, { useState, useEffect } from "react";
import { Button, TextField, Grid, Tooltip, IconButton } from "@mui/material";
import axios from "../../../../axios-order";
import moment from "moment";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ToggleSwitch from "../../../../components/ui/ToggleSwitch/ToggleSwitch";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import GetAppIcon from "@material-ui/icons/GetApp";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { ValidatorForm } from "react-material-ui-form-validator";
import { TextValidator } from "react-material-ui-form-validator";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import DatePicker from "../GSTR-2A_Repository/DatePicker";

const dateFormat = (value) => {
  if (!value) return "";

  const m = moment(value, [
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "DD/MM/YYYY"
  ], true);

  return m.isValid() ? m.format("DD/MM/YYYY") : "";
};


export default function Gstr3bRepository() {
  const [openAndCloseModel, setOpenAndCloseModel] = useState(false);
  const [businessEntityId, setBusinessEntityId] = useState("");
  // const [fileName, setFileName] = useState("");
  // const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [trigarCircularProgress, setTrigarCircularProgress] = useState(false);
  const history = useHistory();

  //...............For Error Message..........................
  const [colorForErrorMessage, setColorForErrorMessage] = useState("red");
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageVisibilityStyle, setErrorMessageVisibilityStyle] =
    useState("hidden");
  const [errorMessageDisplayStyle, setErrorMessageDisplayStyle] =
    useState("none");

  //.........Record From Get Api.................
  const [recordFromApi, setRecordFromApi] = useState([]);
  const [recordFromApiForSearch, setRecordFromApiForSearch] = useState([]);

  const [loaderForTable, setLoaderForTable] = useState(false);
  const [loaderForFileUpload, setLoaderForFileUpload] = useState(false);

  //............File Upload Data Saving in useState................
  const [fileDataToUpload, setFileDataToUpload] = useState("");
  const [GSTJsonfFile, setGSTJsonfFile] = useState("");
  const [fileName, setFileName] = useState("");

  const [snackbarOpen, setSnackbarOpen] = useState(false);

  const [snackbarSeverity, setSnackbarSeverity] = useState("warning");

  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [next, setNext] = useState(false);
  const [fromMonthYearDisplay, setFromMonthYearDisplay] = useState("");
  const [fromToYearDisplay, setFromToYearDisplay] = useState("");
  const [isPaymentRequired, setIsPaymentRequired] = useState(true);

  const handleFileChange = (event) => {
    if (event.target.files[0]) {
      const fileData = event.target.files[0];
      const fileName = fileData.name;
      setFileName(fileName);
      const reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function () {
        const fileValue = reader.result;
        setFileDataToUpload(fileValue);
      };
      event.target.value = null;
    }

  };

  const handleSnackbarOpen = (message, severity) => {
    setSnackbarOpen(true);
    setSnackbarSeverity(severity);
    setResponseMessage(message);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleBackNavigation = () => {
    history.push("/repoCards");
  };

  useEffect(() => {
    getApiForGst2aRepository();
  }, []);

  useEffect(() => {
    checkPaymentRequired(fromMonthYearDisplay);
  }, [fromMonthYearDisplay]);

  const resetFileUpload = () => {
    setFileDataToUpload(null);
    setFileName("");
  };

  const handleSubmit = () => {
    if (!fileDataToUpload) {
      handleSnackbarOpen("Please select to a pdf file", "error");
      return;
    }

    setLoading(true);

    const businessEntityId = localStorage.getItem("business_entity_id");

    const payLoad = {
      business_entity_id: businessEntityId,
      document_name: fileName,
      file: fileDataToUpload,
    };

    axios
      .post("/gstr3b/repository", payLoad)
      .then((res) => {
        setLoading(false);
        getApiForGst2aRepository();

        if (res.data) {
          handleSnackbarOpen(res?.data?.message, "success");
          resetFileUpload();
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("error");

        handleSnackbarOpen(err?.response?.data?.message, "error");
        resetFileUpload();
      });
  };

  const handleChange = (event) => {
    setNext(event.target.checked);
  };

  const checkPaymentRequired = async (fromRetPeriod) => {
    const taxPeriod = fromRetPeriod || moment().format("MMYYYY");
    try {
      const { data } = await axios.get(
        `/check_gstr3b_auto_download_payment_required/${localStorage.getItem("business_entity_id")}/${taxPeriod}`
      );
      setIsPaymentRequired(data?.is_payment_required);
    } catch (err) {
      console.error("Failed to check payment required:", err);
    }
  };

  const inputHandlerFromPicker = (v) => {
    const formattedDate = v ? moment(v).format('MMYYYY') : '';
    setFromMonthYearDisplay(formattedDate);
    setFromToYearDisplay(formattedDate);
    console.log(formattedDate)
  };

  const handleGSTR3BDownload = async () => {
    setIsSubmitting(true);

    const business_entity_id = localStorage.getItem('business_entity_id');
    const org_gstin = localStorage.getItem('gst');

    let fromRetPeriod = "";
    let toRetPeriod = "";

    if (fromMonthYearDisplay) {
      const parsedFromDate = moment(fromMonthYearDisplay, "MM/YYYY");
      if (parsedFromDate.isValid()) {
        fromRetPeriod = parsedFromDate.format("MMYYYY");
      }
    }

    if (fromToYearDisplay) {
      const parsedToDate = moment(fromToYearDisplay, "MM/YYYY");
      if (parsedToDate.isValid()) {
        toRetPeriod = parsedToDate.format("MMYYYY");
      }
    }

    if (isPaymentRequired) {
      const orderItems = [
        {
          plan_name: "GSTR-3B Auto Download",
          plan_id: "0",
          description: "GSTR3B_AUTO_DOWNLOAD",
          features: [
            { particulars: "GSTR-3B Auto Download", qty: 1, amount: 20.00 },
          ],
          amount: {
            sub_total: 20.00,
            GST_charges: 3.60,
            total: 23.60,
          },
          addOn: [],
          business_entity_id: business_entity_id,
          gstin: org_gstin,
          fromRetPeriod: fromRetPeriod,
          toRetPeriod: toRetPeriod,
        },
      ];
      setIsSubmitting(false);
      history.push("/orderSummary", orderItems);
    } else {
      await callGstr3bDownload(business_entity_id, org_gstin, fromRetPeriod, toRetPeriod);
      setIsSubmitting(false);
    }
  };

  const callGstr3bDownload = async (business_entity_id, gstin, fromRetPeriod, toRetPeriod) => {
    const url = `/gstr3b/passthrough/repository`;
    const payload = { business_entity_id, fromRetPeriod, toRetPeriod, gstin };

    try {
      const response = await axios.post(url, payload);
      const responseData = response.data;

      if (responseData.message_type && responseData.message) {
        handleSnackbarOpen(responseData.message, responseData.message_type);
        return;
      }
      if (responseData.status === "error" && responseData.message) {
        handleSnackbarOpen(responseData.message, "error");
        return;
      }
      if (typeof responseData.status === 'boolean' && responseData.message) {
        const snackbarType = responseData.status ? 'success' : 'error';
        handleSnackbarOpen(responseData.message, snackbarType);
        return;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        const errData = error.response.data;
        const snackbarType = errData.status === true ? 'success' : 'error';
        handleSnackbarOpen(errData.message, snackbarType);
      } else {
        console.log(error);
        handleSnackbarOpen('Unexpected Error.', 'error');
      }
    }
  };

  const handleOpenAndClose = () => {
    setOpenAndCloseModel(!openAndCloseModel);
    setTrigarCircularProgress(false);
    setColorForErrorMessage("red");
    setErrorMessage("");
    setErrorMessageVisibilityStyle("hidden");
    setErrorMessageDisplayStyle("none");
    setFileDataToUpload("");
    setFileName("");
    setLoaderForFileUpload(false);
  };

  const fileUploadCancelButtonHandler = () => {
    setTrigarCircularProgress(false);
    setColorForErrorMessage("red");
    setErrorMessage("");
    setErrorMessageVisibilityStyle("hidden");
    setErrorMessageDisplayStyle("none");
    setFileDataToUpload("");
    setFileName("");
    setLoaderForFileUpload(false);
  };

  const downloadBase64File = (contentType, base64Data, fileName) => {
    // Decode the base64 string
    const decodedData = atob(base64Data.split(",")[1]);

    // Create a Blob object from the decoded data
    const blob = new Blob([decodedData], { type: contentType });

    // Create a download link for the Blob
    const downloadLink = document.createElement("a");
    const url = URL.createObjectURL(blob);
    downloadLink.href = url;
    downloadLink.download = fileName;
    downloadLink.click();

    // Revoke the object URL after the download
    URL.revokeObjectURL(url);
  };

  const downloadFile = (document_id) => {
    const businessEntityId = localStorage.getItem("business_entity_id");
    axios
      .get(`gstr3b/download_document/${businessEntityId}/${document_id}`)
      .then((res) => {
        if (!res.data) {
          return;
        }

        const { report_type, records } = res.data;

        if (report_type === "json") {
          // If the report type is JSON, decode and download it as JSON
          downloadBase64File("application/json", records, "report.json");
        } else if (report_type === "pdf") {
          // For PDF, use the base64-encoded data directly
          const downloadLink = document.createElement("a");
          downloadLink.href = records;
          downloadLink.download = "GSTR-3B.pdf";
          downloadLink.click();
        }
      })
      .catch((err) => {
        console.error("Error during file download:", err);
      });
  };




  const getApiForGst2aRepository = () => {
    const businessEntityId = localStorage.getItem("business_entity_id");

    axios
      .get(`gstr3b_repository/${businessEntityId}`)
      .then((res) => {
        if (res.data) {
          // console.log(res.data.records)
          setRecordFromApi(res.data.records);
        }
      })
      .catch((err) => { });
  };

  const newReconModalClose = () => {
    setFileName("");
    setFromMonthYearDisplay("");
    setFromToYearDisplay("");
    setFileDataToUpload("");
    setErrorMessage("");
  };

  return (
    <React.Fragment>
      <div style={{ padding: "15px 20px", backgroundColor: "#f5f5f5" }}>
        <Tooltip title="Back" arrow>
          <IconButton
            onClick={handleBackNavigation}
            sx={{
              borderRadius: '50%',
              padding: '6px',
              color: '#263238',
              fontSize: '20px',
              backgroundColor: '#ffffff',
              height: '36px',
              width: '36px',
              '&:hover': {
                backgroundColor: '#455a64',
                color: '#ffffff',
              },
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
              transition: 'background-color 0.3s ease',
            }}
          >
            <ArrowBackIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Tooltip>
      </div>
      <BoxWrapper
        boxTitle={
          <div style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            paddingRight: "20px",
            position: "relative"
          }}>
            <span style={{ fontWeight: 600, color: "#000" }}>
              GSTR-3B Repository
            </span>
            <span style={{ fontWeight: 600, position: "absolute", left: "45%", transform: "translateX(-50%)" }}>
              GSTR-3B Auto Download
            </span>
          </div>
        }
      >
        <ValidatorForm
          onSubmit={(e) => {
            e.preventDefault();
            if (fileName && fileDataToUpload) {
              handleSubmit();
            } else if (fromMonthYearDisplay && fromToYearDisplay) {
              handleGSTR3BDownload();
            }
          }}
          onError={(errors) => console.log(errors)}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '40px' }}>
              {/* Upload Button */}
              <div style={{ minWidth: '100px' }}>
                <label
                  className="button-primary"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    cursor: fromMonthYearDisplay ? "not-allowed" : "pointer",
                    padding: "8px",
                    display: 'block',
                    opacity: fromMonthYearDisplay ? 0.5 : 1,
                    pointerEvents: fromMonthYearDisplay ? 'none' : 'auto'
                  }}
                >
                  Upload
                  <input
                    type="file"
                    accept=".pdf"
                    onChange={handleFileChange}
                    hidden
                    disabled={!!fromMonthYearDisplay}
                  />
                </label>
              </div>

              {/* File name field */}
              <div style={{ flex: '0 0 350px' }}>
                <TextField
                  placeholder="Choose file"
                  value={fileName}
                  variant="standard"
                  fullWidth
                  disabled={!!fromMonthYearDisplay}
                  style={{ opacity: fromMonthYearDisplay ? 0.5 : 1 }}
                  inputProps={{
                    readOnly: true,
                  }}
                />
              </div>

              {/* From Date Picker */}
              <div style={{ flex: '0 0 300px', opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                  Please Select From Month and Year <span style={{ color: 'red' }}>*</span>:
                </label>
                <DatePicker
                  views={['year', 'month']}
                  placeholder="From Year to Month"
                  format="MM/yyyy"
                  value={fromMonthYearDisplay}
                  onChange={inputHandlerFromPicker}
                  disabled={!!fileName}
                />
              </div>

              {/* To Date Picker */}
              <div style={{ flex: '0 0 300px', opacity: fileName ? 0.5 : 1 }}>
                <label style={{ color: 'black', display: 'block', marginBottom: '4px', fontSize: '14px' }}>
                  Please Select To Month and Year <span style={{ color: 'red' }}>*</span>:
                </label>
                <DatePicker
                  views={['year', 'month']}
                  placeholder="From Year to Month"
                  format="MM/yyyy"
                  value={fromToYearDisplay}
                  onChange={inputHandlerFromPicker}
                  disabled={true}
                />
              </div>

              {/* Button Group */}
              <div style={{ display: 'flex', gap: '5px', marginLeft: '-25px' }}>
                <div style={{ minWidth: '100px' }}>
                  <button
                    className="button-primary"
                    type="submit"
                    style={{ width: '100%', padding: '8px' }}
                    disabled={isSubmitting || loading}
                  >
                    {(isSubmitting || loading) ? 'Submitting...' : 'Submit'}
                  </button>
                </div>

                <div style={{ minWidth: '100px' }}>
                  <button
                    type="button"
                    className="button-outlined-secondary"
                    onClick={newReconModalClose}
                    style={{ width: '100%', padding: '8px' }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </ValidatorForm>
        {errorMessage && (
          <p style={{ color: "red", marginTop: "10px" }}>{errorMessage}</p>
        )}
      </BoxWrapper>

      {/*..................Table.......................*/}
      <BoxWrapper
        boxTitle="History"
        enableAddButton={true}
        addButtonLabel="Refresh"
        addButtonHandlerFn={getApiForGst2aRepository}
      >
        <div className="responsive-table">
          <table className="custome-table">
            <thead>
              <tr>
                <th>ARN</th>
                <th>TAX PERIOD</th>
                <th>FINANCIAL YEAR</th>
                <th>UPLOAD DATE</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {recordFromApi.map((v, index) => (
                <tr key={index}>
                  <td style={{ textTransform: "capitalize" }}>{v.arn}</td>
                  <td style={{ textTransform: "capitalize" }}>{v.period}</td>
                  <td>{v.financial_year}</td>
                  <td style={{ textTransform: "capitalize" }}>
                    {v.created_time ? dateFormat(v.created_time) : ""}
                  </td>
                  <td>
                    <GetAppIcon
                      className="action-icon-button download"
                      onClick={() => downloadFile(v.id)}
                    />
                  </td>
                </tr>
              ))}
              {loaderForTable ? (
                <tr>
                  <td
                    colSpan={5}
                    style={{
                      color: "black",
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Loading…Please wait
                  </td>
                </tr>
              ) : recordFromApi?.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ color: "red", textAlign: "center" }}>
                    No Data Found!
                  </td>
                </tr>
              ) : (
                ""
              )}
            </tbody>
          </table>
        </div>
      </BoxWrapper>

      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
        style={{ maxWidth: "25%" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
        >
          {responseMessage}
        </MuiAlert>
      </Snackbar>
    </React.Fragment>
  );
}